<template>
    <Head :title="userFullName" />
    <div class="w-full">
        <div class="w-full dark:bg-gray-900">
            <div>
                <img class="h-32 w-full object-cover lg:h-48" :src="profile.backgroundImage" alt="" />
            </div>
            <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="-mt-12 sm:-mt-16 flex  justify-center items-center space-x-5">
                    <div class="flex">
                        <img class="w-24 rounded-full ring-4 ring-white dark:ring-gray-900 sm:h-32 sm:w-32" :src="profile.avatar" alt="" />
                    </div>
                    <div class="mt-6 sm:mt-10 sm:flex-1 sm:min-w-0 sm:flex sm:items-center sm:justify-end sm:space-x-6 sm:pb-1">
                        <div class="md:block mt-6 min-w-0 flex-1">
                            <h1 class="pt-1.5 text-2xl font-bold text-gray-900 dark:text-white">
                                {{ userFullName }}
                            </h1>
                            <p class="text-sm mt-1 font-thin text-gray-500 dark:text-gray-300 truncate">
                                {{ userEmailAddress }} - {{ userRoles }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="px-8 mt-10">
            <roles />
        </div>
        <div class="px-8 mt-10">
            <notification-groups />
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Roles from '@/Pages/Profile/Roles'
import { Head, Link} from "@inertiajs/inertia-vue3";
import NotificationGroups from '@/Pages/Profile/NotificationGroups'

import {
    LogoutIcon
} from '@heroicons/vue/solid';

const profile = {
    avatar:
        'https://images.unsplash.com/photo-1517365830460-955ce3ccd263?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=256&h=256&q=80',
    backgroundImage:
        'https://images.unsplash.com/photo-1444628838545-ac4016a5418a?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
}

export default {
    layout: Layout,
    props: {
        auth: Object,
    },
    components: {
        Head,
        Link,
        Roles,
        LogoutIcon,
        NotificationGroups,
    },
    computed: {
        userFullName() {
            return this.auth.user.name
        },
        userEmailAddress() {
            return this.auth.user.email
        },
        userRoles() {
            return this.auth.user.roles.map(role => role.name).join(", ")
        },
        userPermissions() {
            console.log(this.auth.user.roles.map(role => [...role.permissions]))
            return true;
            // return this.auth.user.roles.map(role => [...role.permissions]);
        }
    },
    setup() {
        return {
            profile,
        }
    },
}
</script>
